<template>
	<div class="index">
    <router-view />
		<layoutFooter />
	</div>
</template>

<script>
	import layoutFooter from '@/components/layout/footer'


  export default {
		components: {
			layoutFooter
		},
		name: 'index',
		data() {
			return {}
		},
		created() {

    },
		mounted() {},

	}
</script>

<style lang="scss" scoped>
	.index {
	}
</style>
